import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ModalHeader from "../modal/ModalHeader";
import ModalFooter from "../modal/ModalFooter";
import angular from 'angular';
import '../../angular_apps/main/apt';
import { angular2react } from 'angular2react'
import historyModule from '../../angular_apps/clink_manager/scripts/controllers/history';

let $injector:any;
const historyAngularComponent = {
  bindings: {
    clink: '<'
  },
  templateUrl: 'static/templates/history.html',
  controller: 'HistoryCtrl'
}

// Expose components to Angular
historyModule
  .run(['$injector', function (_$injector:any) { $injector = _$injector }])
  .component('historyMain', historyAngularComponent);

angular.bootstrap(document.createElement('div'), ['historyMain'], { strictDi: true });
let History:any;

function ModalHistory(props:any) {
  const { showHistory, setShowHistory, clink, app } = props;
  const [showHistoryAngularComponent, setShowHistoryAngularComponent] = useState(false);

  useEffect(() => {
    if (showHistory) {
      History = angular2react('historyMain', historyAngularComponent, $injector);
      setShowHistoryAngularComponent(true);
    }
  }, [clink, showHistory]);

  return (
    <Modal
      dialogClassName="modal-history"
      show={showHistory} onHide={() => setShowHistory(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ maxHeight: "95vh" }}
    >
      <ModalHeader title="cLink History" useIcon={true} icon={app.icon ? app.icon : null} />
      <Modal.Body style={{ maxHeight: "calc(95vh - 200px)", overflowY: "auto" }}>
        {
          (showHistoryAngularComponent) ? <History clink={clink} /> : null
        }
      </Modal.Body>
      <ModalFooter close={() => setShowHistory(false)}/>
    </Modal>
  );
}
export default ModalHistory;
